import { useFormContext } from 'react-hook-form';
import { FfcChildProps, getFieldErrors } from '../shared';
import { FormEditorForm } from '../../../shared';
import FieldTitle from './FieldTitle';
import FieldHelpText from './FieldHelpText';
import RequiredSwitch from './RequiredSwitch';
import FieldConfigurationWrapper from './FieldConfigurationWrapper';
import MultiSwitch from './MultiSwitch';
import FieldOptionLst from './FieldOptionLst';
import * as DisplayStrings from '../../../../../displayStrings';

const SystemOnlyDropdownFieldConfiguration = ({ fieldIndex, fieldLabel }: FfcChildProps) => {
  const { control, formState } = useFormContext<FormEditorForm>();
  const { label: titleError, helptext: descriptionError } = getFieldErrors(formState.errors.fields, fieldIndex);

  return (
    <FieldConfigurationWrapper>
      <FieldTitle control={control} fieldIndex={fieldIndex} error={titleError} />
      <FieldHelpText control={control} fieldIndex={fieldIndex} error={descriptionError} />
      <FieldOptionLst fieldIndex={fieldIndex} control={control} />
      <MultiSwitch control={control} fieldIndex={fieldIndex} isDisabled={true} />
      <RequiredSwitch
        control={control}
        fieldIndex={fieldIndex}
        isDisabled={true}
        tooltip={DisplayStrings.DisableRequiredTooltip(fieldLabel)}
      />
    </FieldConfigurationWrapper>
  );
};

export default SystemOnlyDropdownFieldConfiguration;
